/* `params` is a caller-supplied dependency array. `getBloc` is deliberately untracked:
   call sites pass an inline arrow, so tracking it would rebuild the BLoC every render. */
/* oxlint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import { BLoCBase } from "./classes/BLoCBase";
import { IBLoC } from "./types/IBLoC";
import { Observable } from "rxjs";

export const useInitBLoC = <T extends IBLoC & BLoCBase<any>>(
  getBloc: () => T | null | undefined,
  params: any[] = [],
) => {
  const isFirstRunMem = useRef<any[] | null>(null);

  const [bloc, setBloc] = useState<T | null>(null);
  useEffect(() => {
    isFirstRunMem.current = params;
    const newB = getBloc() || null;
    if (newB) {
      Object.keys(newB).forEach(
        (key) =>
          newB[key as never] &&
          !["subs", "state"].includes(key) &&
          !((newB[key as never] as any) instanceof Observable) &&
          !((newB[key as never] as any) instanceof Function) &&
          !(newB[key as never] as any)?.watch &&
          Object.freeze(newB[key as never]),
      );
    }
    setTimeout(() => setBloc(newB ? Object.freeze(newB) : null));
    return () => {
      setBloc(null);
    };
  }, [...params]);
  useEffect(() => {
    if (bloc?.onInit) {
      bloc.onInit();
    }
    return () => {
      if (bloc?.unsub) {
        bloc.unsub();
      }
      if (bloc?.onDestroy) {
        bloc.onDestroy();
      }
      if (bloc?.onDestroyBase) {
        bloc.onDestroyBase();
      }
    };
  }, [bloc]);
  return bloc as Readonly<T>;
};
